
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};

@Injectable()
export class LoanRecoverySetupService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

 
    getAllLoanRecoverySetups() {
         return this.http.get(`setup/loanRecoverySetup`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    GetAllProductType() {
         return this.http.get(`setup/product-type`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }


    GetAllCasa() {
         return this.http.get(`setup/casa`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);

    }

    
    GetAllAgent() {
        return this.http.get(`setup/agent`).pipe(
           map((res: any) => res),
           catchError((error: any) => observableThrowError(error.error || 'Server error')),);

   }

    
    getLoanRecoverySetups(id) {
        return this.http.get(`setup/getloanRecoverySetup/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    save(body) {
        let bodyObj = JSON.stringify(body);
     
        return this.http.post(`setup/addloanRecoverySetup`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    update(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setup/updateloanRecoverySetup/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
}